import { axiosInstance } from "../../../utils";

const actions = {
  CREATE_OR_UPDATE_INSURANCE_COMPANY_REQUESTED:
    "CREATE_OR_UPDATE_INSURANCE_COMPANY_REQUESTED",
  CREATE_OR_UPDATE_INSURANCE_COMPANY_SUCCEEDED:
    "CREATE_OR_UPDATE_INSURANCE_COMPANY_SUCCEEDED",
  CREATE_OR_UPDATE_INSURANCE_COMPANY_FAILED:
    "CREATE_OR_UPDATE_INSURANCE_COMPANY_FAILED",

  addOrUpdateInsuranceCompany: (data = undefined) => ({
    type: actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_REQUESTED,
    payload: data,
  }),

  createOrUpdateInsuranceCompany: async (data = undefined) => {
    const bodyFormData = new FormData();

    if (data.name != null) bodyFormData.set("name", data.name);
    if (data.description != null)
      bodyFormData.set("description", data.description || "");
    bodyFormData.set(
      "is_active",
      data.is_active === true || data.is_active === "true"
    );

    const services = Array.isArray(data.enabled_services)
      ? data.enabled_services
      : [];
    bodyFormData.set("enabled_services", JSON.stringify(services));

    if (data.logo) bodyFormData.append("logo", data.logo);

    if (data._id) {
      const url = `insurance_companies/${data._id}`;
      const res = await axiosInstance.put(url, bodyFormData);
      return res.data;
    }

    const url = `insurance_companies/create`;
    const res = await axiosInstance.post(url, bodyFormData);
    return res.data;
  },
};

export default actions;
